import { render, staticRenderFns } from "./VehicleAddForm.vue?vue&type=template&id=62e6bedf&scoped=true&"
import script from "./VehicleAddForm.vue?vue&type=script&lang=ts&"
export * from "./VehicleAddForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e6bedf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
